<template>
  <el-dialog :title="$t('PAGE_KPMG_ROLE_TITLE_group')"
             visible
             width="70%"
             @close="onCancel">

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             :inline="true"
             label-width="100px"
             class="demo-ruleForm">
      <el-form-item class="form-item"
                    :label="$t('TABLE_HEADER_roleName')"
                    prop="roleName">
        <el-input
                class="form-input-item"
                v-model="ruleForm.roleName"
                  maxlength="100"></el-input>
      </el-form-item>
      <el-form-item class="form-item"
                    :label="$t('FORM_LABEL_description')"
                    prop="description">
        <el-input
                class="form-input-item"
                v-model="ruleForm.description"
                  maxlength="100"></el-input>
      </el-form-item>
    </el-form>
    <el-row>
      <p class="title"> {{$t('PAGE_CLIENTROLES_PERMISSION')}}</p>
    </el-row>
    <el-row class="permission-box"
            :gutter="16">
      <el-col :span="24">
        <div class="box-item">
          <p class="item-title">
            <span>*</span>
            {{$t('COMMON_ENTITY')}}
            <span style="color:#fd349c;">{{ $t('kprole_entity_confirmation_tip') }}</span>
          </p>
          <div class="item-content with-select-all-tree">
            <el-input :placeholder="$t('ENTER_SEARCH_CONTENT')" class="entity-input-sel" v-model="filterText" />
            <el-tree :default-expand-all="true"
                     :check-strictly="true"
                     :expand-on-click-node="false"
                     :data="data"
                     :props="defaultProps"
                     :default-checked-keys="entityTreeCheckedList"
                     :render-content="renderContent"
                     :filter-node-method="filterNode"
                     node-key="key"
                     show-checkbox
                     @check="handleCheckChange"
                     ref="tree"></el-tree>
          </div>
        </div>
      </el-col>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 :loading="saveLoading"
                 @click="onConfirm"
                 class="wl-green">{{$t('btn_save')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { dateFormat, UserInput } from '@/utils'

export default {
    data() {
        return {
            filterText: '',
            data: [
                {
                    id: '001',
                    siteId: '001',
                    parentKey: '',
                    entityName: 'ClientA',
                    entityDesc: 's',
                    entityType: 'root',
                    seq: '',
                    key: '001',
                    childEntity: []
                }
            ],
            defaultProps: {
                children: 'childEntity',
                label: 'entityName'
            },
            ruleForm: {
                roleName: '',
                description: ''
            },
            entityTreeCheckedList: [],
            switchFlag: 0
        }
    },
    computed: {
        rules() {
            const rules = {
                roleName: [
                    { required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' },
                    {
                        pattern: UserInput.reg,
                        trigger: 'blur',
                        message: this.$t('ILLEGAL_USER_INPUT_01')
                    }
                ],
                description: []
            }
            return rules
        },
        renderContent() {
            // 監聽改變
            this.switchFlag;
            return (h, { node, data, store }) => {
                let isSelectAll = false
                let currentAllNodes = []
                const showTag = Array.isArray(data.childEntity) && data.childEntity.length > 0
                if (showTag) {
                    [isSelectAll, currentAllNodes] = this.isAllSelected(data)
                }
                return (
                    <span class="custom-tree-node" >
                        <span>{node.label}</span>
                        {
                            showTag && (
                                <span class="add-icon" onClick={() => this.switchSelect(isSelectAll, currentAllNodes)}>
                                    {isSelectAll ? this.$t('unselect_all') : this.$t('select_all')}
                                </span>
                            )
                        }
                    
                    </span>
                );
            }
        }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    filters: {
        formatDate: value => {
            return dateFormat(new Date(value),'yyyy-MM-dd')
        }
    },
    methods: {
        isAllSelected(data) {
            const stack = [data]
            const allNodes = [data]
            let isAllSelected = true
            while(stack.length) {
                const node = stack.pop()
                if (node.childEntity) {
                    node.childEntity.forEach(item => {
                        stack.push(item)
                        allNodes.push(item)
                    })
                }
                if (!node.checked) isAllSelected = false
            }
console.log("isAllSelected***",isAllSelected,data,)
            return [isAllSelected, allNodes]
        },
        switchSelect(isAllSelected, allNodes) {
            console.log("switchSelect****",isAllSelected)
          // 存在过滤条件的全选/不全选
          if(this.filterText.length > 0) {
            if(allNodes.some(item => item.entityType === 'ROOT')) {
              let subTemp = allNodes.filter(item => (item.entityName.indexOf(this.filterText) != -1 && item.entityType === 'SUB_ENTITY'))
              let idList = []
              subTemp.forEach(item => {
                idList.push(item.id)
                idList.push(item.parentKey)
              })
              let entityTemp = allNodes.filter(node => idList.indexOf(node.id) != -1 || idList.indexOf(node.key) != -1)
              let rootTemp = allNodes.filter(item => item.entityType === 'ROOT')
              allNodes = entityTemp.concat(rootTemp)
            } else {
              allNodes = allNodes.filter(item => (item.entityName.indexOf(this.filterText) != -1 && item.entityType === 'SUB_ENTITY') || item.entityType === 'ENTITY')
            }
          }
            if (isAllSelected) {
                allNodes.forEach(item => {
                    item.checked = false
                    this.$refs.tree.setChecked(item.key, false)
                })
            } else {
                allNodes.forEach(item => {
                    this.$refs.tree.setChecked(item.key, true)
                    item.checked = true
                })
            }
            this.switchFlag = this.switchFlag === 0 ? 1 : 0
        },
        getCheckedPbcList(arr) {
            if (arr instanceof Array) {
                const list = []
                arr.forEach((i, n) => {
                    if (i.checked) {
                        list.push(i.id)
                    }
                })
                return list
            }
        },
        getCheckedTreeList(arr) {
            if (arr instanceof Array) {
                const list = []
                arr.forEach((i, n) => {
                    list.push(i.id)
                })
                return list
            }
        },

        filterNode(value, data) {
            if (!value) return true
            console.log(value,data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1,data,665)
            return data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1
        },
        handleCheckChange(data, {checkedNodes}) {
            this.switchFlag = this.switchFlag === 0 ? 1 : 0
            data.checked = !data.checked
        },
        onConfirm() {
            this.$refs.ruleForm.validate(validate => {
                if (validate) {
                    if(this.getCheckedTreeList(this.$refs.tree.getCheckedNodes()).length>0){
                        this.onAdd({
                            roleId: this.roleId,
                            base: this.ruleForm,
                            entityIdList: this.getCheckedTreeList(this.$refs.tree.getCheckedNodes())
                        })
                    }else {
                        this.$message.error(this.$t('CLIENT_ROLE_ENTITY'))
                    }
                }
            })
        },
        getEntityTreeDefaultChecked(node) {
            node.forEach((i, n) => {
                if (i.checked) {
                    this.entityTreeCheckedList.push(i.key)
                }
                if (i.childEntity && i.childEntity.length > 0) {
                    this.getEntityTreeDefaultChecked(i.childEntity)
                }
            })
        }
    },
    mounted() {
        if (this.initData) {
            this.data = [this.initData]
            this.getEntityTreeDefaultChecked(this.data)
            this.ruleForm.roleName = this.initData.row.roleName
            this.ruleForm.description = this.initData.row.roleDesc
            this.roleId = this.initData.row.roleId
        }
    },
    props: {
        onAdd: Function,
        onCancel: Function,
        saveLoading: Boolean,
        initData: [String, Object]
    }
}
</script>
<style>
.with-select-all-tree .custom-tree-node{
    display: inline-block;
    width: 100%;
    padding-right: 10px;
}

.with-select-all-tree .custom-tree-node .add-icon{
    float: right;
    color: #409eff;
}
.with-select-all-tree .custom-tree-node .add-icon:hover{
    color: #66b1ff;
}
.with-select-all-tree .el-tree{
    width: 500px;
}
</style>
<style scoped>
.title {
    font-size: 12PX;
    color: #555555;
    padding: 5px 0 15px 0;
}
.form-item{
  width: calc((100% - 10px) / 2);
}
.demo-ruleForm .el-form-item:nth-child(2){
  margin-right: 0 !important;
}
.form-item ::v-deep .el-form-item__content{
  width: 400px;
}
.box-item {
    border: 1PX solid #cccccc;
}

.item-title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background-color: #f4f4f4;
    font-weight: 700;
    font-size: 11PX;
    font-style: normal;
}
.item-title > span {
    padding: 0 2px 0 0;
    color:#fd349c;
}
.item-content {
    height: 240px;
    overflow-y: auto;
}

.change-btn {
    display: block;
    float: right;
    margin-right: 8px;
    cursor: pointer;
}

.change-btn:hover {
    color: #0091da;
}

.change-btn-active {
    color: #0091da;
}

.topFilter {
    float: right;
}
.entity-input-sel{
  width: 500px;
  padding: 5px 10px 5px 5px;
  font-size: 12PX;
}
</style>
